<template>
	<v-card class="mx-auto elevation-12" style="max-width: 500px">
		<v-card-title class="text-center headline font-weight-black">
			<v-spacer></v-spacer>
			Resend Confirmation Code
			<v-spacer></v-spacer>
		</v-card-title>
		<v-card-subtitle id="err-message" class="text-center red--text">
			{{ this.errMsg }}
		</v-card-subtitle>
		<v-card-text>
			<v-form v-model="validForm">
				<v-row class="justify-center text-center" dense>
					<v-col cols="12">
						<v-text-field
							v-model="email"
							label="Email"
							name="email"
							hint="Enter the email you want to receive your confirmation code"
							persistent-hint
							type="text"
							outlined
						/>
					</v-col>
					<v-col cols="12 mt-4">
						<v-btn
							class="mb-2 py-5 px-10 text-none"
							depressed
							large
							rounded
							color="primary"
							:disabled="!validForm || loadingRequest"
							:loading="loadingRequest"
							@click="resendConfirmationCode"
							>Send Code
						</v-btn>
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>
	</v-card>
</template>

<script>
import { Auth } from 'aws-amplify';

export default {
	name: 'ResendConfirmationForm',
	data: () => ({
		loadingRequest: false,
		email: '',
		code: '',
		errMsg: '',
		validForm: false,
		emailRules: [v => !!v || 'This field is required', v => /@/.test(v || '') || 'Please enter a valid email'],
	}),
	mounted() {
		const username = this.$route.query && this.$route.query.username;
		if (username) this.email = username;
	},
	methods: {
		async resendConfirmationCode() {
			this.loadingRequest = true;
			await Auth.resendSignUp(this.email.toLowerCase())
				.then(() => {
					this.loadingRequest = false;
					this.$router.push(`/confirm-signup/${this.email.toLowerCase()}`);
				})
				.catch(err => {
					this.loadingRequest = false;
					this.resendConfirmCodeError = true;
					this.errMsg = err.message; //-J no idea what this payload is honestly, could be .message but no assumptions for now.
				});
		},
	},
};
</script>
